export const UNASSIGNED_MODULE_FILTER_ID = 'unassigned';
export const UNASSIGNED_MODULE_FILTER_TYPE = 'UnassignedModule' as const;
